<template>
  <div class="notification-history-page">
    <p class="text-muted mb-2">
      Все ранее отправленные уведомления.
    </p>

    <vue-good-table
      :columns="historyColumns"
      :rows="history"
      :pagination-options="{ enabled: true, perPage: 15 }"
      style-class="vgt-table striped"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'createdAt'">
          {{ formatNotificationDate(props.row.createdAt) }}
        </span>
        <span v-else-if="props.column.field === 'creator'">
          {{ formatCreator(props.row.creator) }}
        </span>
        <span v-else-if="props.column.field === 'recipientType'">
          {{ recipientTypeLabel(props.row.recipientType) }}
        </span>
        <span v-else-if="props.column.field === 'relatedStartName'">
          {{ props.row.relatedStartName || '—' }}
        </span>
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ statusLabel(props.row.status) }}
          </b-badge>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <span
        slot="emptystate"
        class="empty-table-title"
      >
        История пуста — отправьте первое уведомление
      </span>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { BBadge } from 'bootstrap-vue'
import {
  formatCreator,
  formatNotificationDate,
  recipientTypeLabel,
  statusLabel,
  statusVariant,
} from './notifications.utils'

export default {
  name: 'NotificationHistoryTab',
  components: {
    VueGoodTable,
    BBadge,
  },
  data() {
    return {
      history: [],
      historyColumns: [
        { label: 'Заголовок', field: 'title' },
        { label: 'Старт', field: 'relatedStartName' },
        { label: 'Дата', field: 'createdAt' },
        { label: 'Отправил', field: 'creator' },
        { label: 'Тип получателей', field: 'recipientType' },
        { label: 'Получателей', field: 'recipientsCount', type: 'number' },
        { label: 'Статус', field: 'status' },
      ],
    }
  },
  async mounted() {
    await this.loadHistory()
  },
  methods: {
    formatNotificationDate,
    formatCreator,
    recipientTypeLabel,
    statusLabel,
    statusVariant,
    async loadHistory() {
      const { data } = await this.$http.get('notifications/history', { params: { maxResultCount: 50 } })
      this.history = data.rows || []
    },
  },
}
</script>
